'use es6';

import Client from 'ads-account-connection/data/Client';
import Raven from 'raven-js';
const AUTH_BASE = `ads/v1/auth`;
const AD_ACCOUNTS_BASE = `ads/v1/ad-account`;
const PIXEL_BASE = `ads/v1/pixel`;
export default {
  generateOAuthorKey(network, networkUserId) {
    return Client.apiRequest(`${AUTH_BASE}/${network.toLowerCase()}/${networkUserId}`, {
      type: 'POST'
    });
  },

  fetchAvailableAdAccounts(network) {
    return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}/available`, {
      type: 'GET',
      timeout: 60000
    }).catch(err => {
      if (err && err.responseJSON && err.responseJSON.errorType === 'NOT_AN_ADWORDS_USER') {
        return [];
      } else {
        throw err;
      }
    });
  },

  selectAdAccounts(network, networkUserId, accountsWithTrackingStatus) {
    return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}`, {
      type: 'PUT',
      query: {
        networkUserId
      },
      data: accountsWithTrackingStatus
    });
  },

  deleteAdAccount(network, adAccountId) {
    return Client.apiRequest(`${AD_ACCOUNTS_BASE}/${network.toLowerCase()}/${adAccountId}`, {
      type: 'DELETE'
    });
  },

  fetchConnectedAuths() {
    return Client.apiRequest(AUTH_BASE);
  },

  // Fetching Facebook Business Extension Login
  fetchFBELogin(adAccountId, pixelId) {
    return Client.apiRequest(`${AUTH_BASE}/facebook/business_extension/login`, {
      type: 'GET',
      query: {
        adAccountId,
        pixelId
      }
    });
  },

  sendConversionEvents(adAccountId, pixelId, data, enabled, sendAllEventsConsent) {
    return Client.apiRequest(`${PIXEL_BASE}/facebook/account/${adAccountId}/pixel/${pixelId}/send-conversion-events`, {
      type: 'PUT',
      query: {
        enabled,
        sendAllEventsConsent
      },
      data
    });
  },

  hasCookieBannerInfo() {
    return Client.apiRequest(`cookiebanner/v1/optin-v2`).then(response => {
      const version = response.optin && response.optin.optinStatus === false ? 'v1' : 'v2';
      return Client.apiRequest(`cookiebanner/${version}/settings`).then(settings => {
        if (version === 'v1') {
          const defaultEnabled = settings.defaultSetting.enabled;
          const overridesEnabled = settings.overrides.filter(override => override.enabled === true).length > 0;
          return defaultEnabled || overridesEnabled;
        } else {
          return settings.some(banner => banner.enabled);
        }
      });
    }).catch(error => {
      Raven.captureMessage('Failed to find cookiebanner version', {
        extra: {
          error
        }
      });
      return false;
    });
  },

  setupConversionsAPI(data) {
    return Client.apiRequest(`${AUTH_BASE}/facebook/business_extension/pixel`, {
      type: 'POST',
      data
    });
  }

};